//定义一个常量user
const user = {
//如果localStorage 中存在则使用localStorage 中数据  否则创建一个空 user   解决页面刷新丢失数据
  state: JSON.parse(localStorage.getItem('ssessionLoginUser')) ? JSON.parse(localStorage.getItem('ssessionLoginUser')) : {
    user: {
		ftype:''
	},
	ywFwjg:{},
	islogin:false,
	browser:undefined,
	enabled:true,
	expireTime:0,
	ipaddr:undefined,
	loginLocation:undefined,
	loginTime:0,
	os:undefined,
	permissions:undefined,
	token:undefined,
	
  },
//获取对象  this.$store.getters.getUser;
  getters: {
    getYwFwjg(state) {
      return state.ywFwjg;
    },
	getUser(state) {
	  return state.user;
	},
	getIslogin(state) {
	  return state.islogin;
	},
	getBrowser(state) {
	  return state.browser;
	},
	getEnabled(state) {
	  return state.enabled;
	},
	getExpireTime(state) {
	  return state.expireTime;
	},
	getIpaddr(state) {
	  return state.ipaddr;
	},
	getLoginLocation(state) {
	  return state.loginLocation;
	},
	getLoginTime(state) {
	  return state.loginTime;
	},
	getOs(state) {
	  return state.os;
	},
	getPermissions(state) {
	  return state.permissions;
	},
	getToken(state) {
	  return state.token;
	},
	
  },
  //更新对象 this.$store.updateUser();
  mutations: {
    SET_USER: (state, user) => {
      state.user = user
    },
	SET_YW_FWJG: (state, info) => {
	  state.ywFwjg = info
	},
	SET_ISLOGIN: (state, islogin) => {
	  state.islogin = islogin
	},
	SET_BROWSER: (state, browser) => {
	  state.browser = browser
	},
	SET_ENABLED: (state, enabled) => {
	  state.enabled = enabled
	},
	SET_EXPIRE_TIME: (state, expireTime) => {
	  state.expireTime = expireTime
	},
	SET_IPADDR: (state, ipaddr) => {
	  state.ipaddr = ipaddr
	},
	SET_LOGIN_LOCATION: (state, loginLocation) => {
	  state.loginLocation = loginLocation
	},
	SET_LOGIN_TIME: (state, loginTime) => {
	  state.loginTime = loginTime
	},
	SET_OS: (state, os) => {
	  state.os = os
	},
	SET_PERMISSIONS: (state, permissions) => {
	  state.permissions = permissions
	},
	SET_TOKEN: (state, token) => {
	  state.token = token
	},
	LOGOUT (state){
		// localStorage.clear();
		state.user = {ftype:''};
		state.ywFwjg = {};
		state.islogin = false;
		state.browser = undefined;
		state.enabled = true;
		state.expireTime = 0;
		state.ipaddr = undefined;
		state.loginLocation = undefined;
		state.loginTime = 0;
		state.os = undefined;
		state.permissions = undefined;
		state.token = undefined;
	},
  },
//异步更新对象   this.$store.dispatch("asyncLoginuser",repos.data.data);
  actions: {
    asyncLoginuser(context, user) {
	  context.commit('SET_USER', user);
	},
	asyncYwFwjg(context, info) {
	  context.commit('SET_YW_FWJG', info);
	},
	asyncIslogin(context, islogin) {
	  context.commit('SET_ISLOGIN', islogin);
	},
  }
}

export default user
